import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from "classnames";
import { useCallback, useEffect, useState } from "react";
import { useScrollValue } from "@hooks/useScrollValue";
import { useWindow } from "@hooks/useWindow";
import { useDocument } from "@hooks/useDocument";
import useDebounce from "@hooks/useDebounce";
import Sidebar from "@components/sidebar/Sidebar";
import PageH1 from "@components/seo/PageH1";
import { useHeroTitle } from "@hooks/useHeroTitle";
const InsightDetails = ({ data }) => {
    var _a;
    const progressBarHeight = 8;
    // top margin take in insight-details__progress-container.
    const topMargin = 8;
    const myDocument = useDocument();
    const myWindow = useWindow();
    const megaMenu = myDocument && myDocument.getElementById("header");
    const megaMenuHeight = megaMenu && ((_a = megaMenu === null || megaMenu === void 0 ? void 0 : megaMenu.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.height);
    const defaultProgressBarTop = megaMenuHeight - progressBarHeight;
    const [isMegaMenuHidden, setIsMegaMenuHidden] = useState(false);
    const [progressBarTop, setProgressBarTop] = useState(defaultProgressBarTop);
    const [isUsingOuterH1, setIsUsingOuterH1] = useState(false);
    const hasHeroTitle = useHeroTitle();
    const { scrollValue } = useScrollValue();
    const { debounceFn } = useDebounce({ delay: 100 });
    // If mega menu hidden, use local nav height as basis for progress container position.
    const progressBarTopStyle = isMegaMenuHidden ? progressBarTop - topMargin : defaultProgressBarTop;
    const handleScroll = () => {
        var _a;
        const localNav = myDocument && ((_a = myDocument.getElementById("local-nav")) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect());
        const isHidden = Array.from(megaMenu === null || megaMenu === void 0 ? void 0 : megaMenu.classList).includes("hidden");
        setIsMegaMenuHidden(isHidden);
        if (localNav.top <= (megaMenu === null || megaMenu === void 0 ? void 0 : megaMenu.offsetHeight)) {
            setProgressBarTop(localNav.height);
        }
    };
    const debouncedScroll = debounceFn(handleScroll);
    const listenToPageTitle = useCallback(() => {
        if (myDocument) {
            const elem = myDocument.getElementsByClassName("insight-details__text--outer");
            setIsUsingOuterH1(!!elem && !!elem[0] && elem[0].clientHeight > 0);
        }
    }, [myDocument]);
    useEffect(() => {
        if (myWindow && myDocument && megaMenu) {
            listenToPageTitle();
            const handleResize = () => {
                setProgressBarTop((megaMenu === null || megaMenu === void 0 ? void 0 : megaMenu.getBoundingClientRect().height) - progressBarHeight);
                listenToPageTitle();
            };
            myWindow.addEventListener("resize", handleResize);
            return () => myWindow.removeEventListener("resize", handleResize);
        }
    }, [myWindow, myDocument, megaMenu]);
    useEffect(() => {
        const unsubscribe = myWindow && myWindow.addEventListener("scroll", debouncedScroll);
        return () => myWindow && unsubscribe();
    }, [myWindow]);
    return (_jsxs("div", { className: "insight-details", children: [_jsx("div", { className: "insight-details__progress-container", style: { top: `${progressBarTopStyle}px` }, children: _jsx("div", { className: cn("insight-details__progress-bar"), style: { width: `${scrollValue}%` } }) }), _jsxs("article", { className: "insight-details__container", children: [!!data.title && (_jsx(PageH1, { forceFallback: hasHeroTitle || !isUsingOuterH1, fallbackElement: "h2", className: "insight-details__text insight-details__text--outer", children: data.title })), _jsxs("div", { className: cn("order-3 w-full lg:order-2", { "lg:w-2/3": !!data.sidebar }), children: [!!data.title && (_jsx(PageH1, { forceFallback: hasHeroTitle || isUsingOuterH1, fallbackElement: "h2", className: "insight-details__text insight-details__text--inner", children: data.title })), !!data.description && _jsx("div", { className: "insight-details__description", dangerouslySetInnerHTML: { __html: data.description } }), !!data.content && _jsx("div", { className: "insight-details__content", dangerouslySetInnerHTML: { __html: data.content } })] }), !!data.sidebar && _jsx(Sidebar, { ...data.sidebar })] })] }));
};
export default InsightDetails;
